import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './styles/global.scss'
import { langState, translate } from './utils/lang'

Vue.config.productionTip = false
Vue.prototype.$langState = langState
Vue.prototype.$t = function(key) {
  this.$langState.locale
  return translate(key)
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
